export default {
  // Statistics
  total: "Total",
  totalData: "records",

  // Table column headers
  asset: "Asset",
  tokenContractAddress: "Token Contract Address",
  quantity: "Quantity",
  priceUSDT: "Price (USDT)",
  valueUSDT: "Value (USDT)",
  updateTime: "Update Time",

  // Tooltips
  priceTooltip:
    "Token price is the corresponding USDT price for the current currency, price data is updated daily",
  valueTooltip:
    "Token value is calculated based on token price, token value is affected by various factors and changes in real time, the token value here is for reference only",

  // Loading and status
  loading: "Loading...",
  noData: "No data",
  tooMuchData:
    "Too much transaction data for this address, only conditional queries with sender/receiver address are supported",

  // Download
  downloadDetails: "Download Details",
  downloadNote: "Note: Maximum 10,000 records can be downloaded",
};
